import React from "react";
import {FormProps} from "../../Interfaces/FormInterfaces";
import "./Form.scss";
import {NSerializeJson} from "nserializejson";

export class Form extends React.Component<FormProps, any> {
    protected inner_form: any;

    constructor(props: FormProps) {
        super(props);
        this.doSubmit = this.doSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount(): void {
        const fields = this.getChildrensValues(this);
        this.setState({fields});
        if (this.props.onChange) {
            this.props.onChange(fields, false);
        }
    }

    getChildrensValues(item: any) {
        let fields = {} as any;
        if (item.props && item.props.children) {
            React.Children.forEach(item.props.children,
                (subItem: any) => {
                    const name = subItem.props.name as string;
                    if (subItem.type === 'div') {
                        const otherFields = this.getChildrensValues(subItem);
                        fields = {...fields, ...otherFields};
                    } else if (name) {
                        let value = subItem.props.value;
                        if (subItem.props.inputType && subItem.props.inputType === 'checkbox') {
                            value = subItem.props.checked;
                        }
                        if (subItem.type === 'textarea' || subItem.props.inputType !== 'radio' || subItem.props.checked === true) {
                            fields[name] = value;
                        }
                    }
                });
        }
        return fields;
    }

    getReactChildren(item: any) {
        let children: any[] = [];
        if (item.props && item.props.children) {
            React.Children.forEach(item.props.children,
                (subItem: any) => {
                    const name = subItem.props.name as string;
                    if (subItem.type === 'div') {
                        const otherChildren = this.getReactChildren(subItem);
                        children = [...children, ...otherChildren];
                    } else if (name) {
                        children.push(subItem);
                    }
                });
        }
        return children;
    }


    doSubmit(e: any) {
        e.preventDefault();

        if (this.validateEverything()) {
            this.props.onSubmit(this.filterUndefined(this.getFormData()));
        }
    }

    filterUndefined(data: any) {
        const newData = {} as any;
        for(let key in data) {
            if (data.hasOwnProperty(key) && data[key]) {
                newData[key] = data[key];
            }
        }
        return newData;
    }

    validateEverything() : boolean {
        let valid = true;
        Array.from(this.inner_form).forEach((input: any) => {
            input.dispatchEvent((new Event('blur')));
            if (valid && input.validity && !input.validity.valid) {
                valid = false;
            }
        });
        return valid;
    }

    handleChange(event: any) {

        const obj = this.getFormData();

        if (this.props.onChange) {
            this.props.onChange(obj as any);
        }
    }

    getFormData() {
        const removeSpaces = (obj: { [ key: string ]: string|string[] }) => {
            Object.keys(obj).forEach((key: string) => {
                const value = obj[key];
                if (typeof value !== 'object') {
                    obj[key] = value.toString().trim() === ' ' ? '' : value.toString().trim();
                } else {
                    obj[key] = value.map((value: string) => value.toString().trim() === ' ' ? '' : value.toString().trim());
                }

            });
            return obj;
        };
        return removeSpaces(NSerializeJson.serializeForm(this.inner_form,
            {
                forceNullOnEmpty: false,
                useDotSeparatorInPath: false,
                useNumKeysAsArrayIndex: true,
                onBeforeParseValue: (value: string) => {
                    return ' ' + value;
                }
            }
        ) as any);
    }

    render() {
        return (
            <form ref={ (form) => this.inner_form = form } className="form"
                  onSubmit={ this.doSubmit }
                  onChange={ this.handleChange } noValidate={true}>
                { this.props.header ? <h1>{ this.props.header }</h1> : "" }
                { this.props.children }
            </form>
        );
    }
}